import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { Component, HostListener } from '@angular/core';
import { CustomBatchEditCellRendererParams } from '@ddv/data-grid';
import { ManagerService } from '@ddv/layout';
import { IconComponent } from '@hs/ui-core-presentation';

@Component({
    selector: 'app-batch-edit-cell-renderer',
    styleUrls: ['./batch-edit-cell-renderer.component.scss'],
    templateUrl: './batch-edit-cell-renderer.component.html',
    imports: [
        IconComponent,
    ],
    host: {
        '[class.edited]': 'edited',
    },
})
export class BatchEditCellRendererComponent implements ICellRendererAngularComp {
    protected edited = false;
    protected value = '';
    private params: CustomBatchEditCellRendererParams | undefined;

    constructor(private readonly manager: ManagerService) {
    }

    @HostListener('click', ['$event']) onClick(_: MouseEvent): void {
        if (this.params?.widgetId) {
            this.manager.setMaximizeWidgetActionSubjectValue({ toBeMaximized: true, widgetId: this.params.widgetId });
        }
    }

    agInit(params: CustomBatchEditCellRendererParams): void {
        this.edited = !!params.eParentOfValue?.classList.contains('ag-cell-edited');
        this.value = params.value ?? '';
        this.params = params;
    }

    refresh(_: ICellRendererParams): boolean {
        return false;
    }
}
